export default __webpack_public_path__ + "static/media/history_768.756d500e.webp";